/* eslint-disable no-param-reassign */
import { route } from 'ziggy-js';

export default {
    install: Vue => {
        Vue.prototype.$route = route;
    },
};
